import { Box, Image } from '@chakra-ui/react';
import templateBgImg from 'assets/images/templates_bg.jpg';
import { ChameleonProvider } from 'libs/third-party/Chameleon';

import { DesignAIProvider } from './DesignAIContext';
import { DesignAIModal } from './DesignAIModal';

export const DesignAI = () => {
  return (
    <ChameleonProvider>
      <Box w='100vw' h='100vh' fontFamily='Inter' color='black'>
        <Image src={templateBgImg} w='full' h='full' objectFit='cover' objectPosition='top left' />
        <DesignAIProvider>
          <DesignAIModal isOpen={true} />
        </DesignAIProvider>
      </Box>
    </ChameleonProvider>
  );
};
